// Jeu de questions FIXE du check-in trimestriel (suivi rapide d'un employé).
// Notées de 1 à 5. Modifier cette liste fait évoluer les futurs check-ins ; les
// check-ins déjà enregistrés conservent leurs `answers` (label figé au snapshot).

export const CHECKIN_QUESTIONS = [
  { key: 'objectives', label: 'Atteinte des objectifs' },
  { key: 'engagement', label: 'Engagement & motivation' },
  { key: 'collaboration', label: 'Collaboration' },
  { key: 'autonomy', label: 'Autonomie' },
  { key: 'wellbeing', label: 'Bien-être au travail' },
  { key: 'workload', label: 'Charge de travail' },
] as const

export const CHECKIN_MAX = 5

export type CheckinQuestionKey = (typeof CHECKIN_QUESTIONS)[number]['key']

// Moyenne des notes (0 si vide), arrondie à 1 décimale.
export function checkinAverage(answers: { rating: number }[]): number | null {
  if (answers.length === 0) return null
  const sum = answers.reduce((s, a) => s + a.rating, 0)
  return Math.round((sum / answers.length) * 10) / 10
}
